import { defineComponent as _defineComponent } from 'vue'
import { openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, unref as _unref, resolveComponent as _resolveComponent, createBlock as _createBlock, createElementVNode as _createElementVNode, createVNode as _createVNode, toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, withCtx as _withCtx, Fragment as _Fragment } from "vue"
import _imports_0 from '@/assets/eluma-logo.svg'
import _imports_1 from '@/assets/eluma-text.svg'


const _hoisted_1 = { class: "page-content" }
const _hoisted_2 = ["srcdoc"]
const _hoisted_3 = { class: "grid pt-3" }
const _hoisted_4 = { class: "col-12 md:col-6 lg:col-2" }
const _hoisted_5 = { class: "col-fixed md:col lg:col" }
const _hoisted_6 = {
  class: "mr-2 pt-1",
  style: {"float":"left"}
}
const _hoisted_7 = { class: "col-fixed" }
const _hoisted_8 = {
  key: 0,
  class: "grid h-20rem mt-1 p-2"
}
const _hoisted_9 = { class: "grid pr-3 pl-3" }
const _hoisted_10 = { class: "col mt-2 p-0 w-full" }
const _hoisted_11 = { class: "field w-full" }
const _hoisted_12 = { class: "grid p-3" }
const _hoisted_13 = { class: "col p-5 border-round border-1 border-200 text-center" }
const _hoisted_14 = { class: "grid" }
const _hoisted_15 = { class: "col text-right" }
const _hoisted_16 = ["textContent"]
const _hoisted_17 = { class: "grid pb-5" }
const _hoisted_18 = { class: "col text-center" }
const _hoisted_19 = { class: "grid" }
const _hoisted_20 = { class: "col" }
const _hoisted_21 = { class: "grid" }
const _hoisted_22 = { class: "col text-left font-semibold" }
const _hoisted_23 = { class: "grid" }
const _hoisted_24 = { class: "col text-left font-semibold" }
const _hoisted_25 = ["textContent"]
const _hoisted_26 = { class: "grid" }
const _hoisted_27 = { class: "col text-left font-semibold" }
const _hoisted_28 = ["textContent"]
const _hoisted_29 = { class: "grid" }
const _hoisted_30 = { class: "col text-left font-semibold" }
const _hoisted_31 = ["textContent"]
const _hoisted_32 = { class: "grid" }
const _hoisted_33 = { class: "col text-left font-semibold" }
const _hoisted_34 = ["textContent"]
const _hoisted_35 = { class: "grid" }
const _hoisted_36 = { class: "col text-left font-semibold" }
const _hoisted_37 = ["textContent"]
const _hoisted_38 = { class: "col" }
const _hoisted_39 = { class: "grid" }
const _hoisted_40 = { class: "col text-left font-semibold" }
const _hoisted_41 = ["textContent"]
const _hoisted_42 = { class: "grid" }
const _hoisted_43 = { class: "col text-left font-semibold" }
const _hoisted_44 = ["textContent"]
const _hoisted_45 = { class: "grid pb-5" }
const _hoisted_46 = { class: "col text-center" }
const _hoisted_47 = { class: "grid" }
const _hoisted_48 = { class: "col" }
const _hoisted_49 = ["textContent"]
const _hoisted_50 = ["textContent"]
const _hoisted_51 = ["textContent"]
const _hoisted_52 = ["textContent"]
const _hoisted_53 = ["textContent"]
const _hoisted_54 = { class: "col text-left" }
const _hoisted_55 = { class: "grid" }
const _hoisted_56 = { class: "col" }
const _hoisted_57 = ["textContent"]
const _hoisted_58 = { class: "grid" }
const _hoisted_59 = { class: "col text-center" }
const _hoisted_60 = { class: "grid" }
const _hoisted_61 = { class: "col" }
const _hoisted_62 = ["textContent"]
const _hoisted_63 = ["textContent"]
const _hoisted_64 = ["textContent"]
const _hoisted_65 = ["textContent"]
const _hoisted_66 = ["textContent"]

import { computed, onMounted, onUnmounted, ref, toRefs, watch, nextTick } from 'vue';
import { storeToRefs } from 'pinia';
import { DropdownChangeEvent } from 'primevue/dropdown';
import { useDateTime, useRouting, can } from '@/composables';
import { PersonStores, useProgressReportStore, useReportStore } from '@/store';
import ReportSubjectTitle from '@/views/Reports/components/ReportSubjectTitle.vue';
import ProgressReportQuantity from '@/views/Reports/ProgressReport/ProgressReportQuantity.vue';
import ProgressReportIntensity from '@/views/Reports/ProgressReport/ProgressReportIntensity.vue';
import ProgressReportIntensityType from '@/views/Reports/ProgressReport/ProgressReportIntensityType.vue';
import { PERMISSIONS, EMIT } from '@/enum';
import { ProgressReportInterface } from '@/types';

interface Props {
  studentId?: undefined | string;
}


export default /*@__PURE__*/_defineComponent({
  __name: 'ProgressReport',
  props: {
    studentId: { default: undefined }
  },
  emits: [EMIT.QUERY_PARAMS],
  setup(__props: any, { emit: __emit }) {

const props = __props;

const { studentId } = toRefs(props);

const $routing = useRouting();

const expandedRows = ref([]);
const reportHtml = ref('');
const showIframe = ref(false);

const emit = __emit;

const profileStore = PersonStores.useUserProfileStore();
const reportStore = useReportStore();
const progressReportStore = useProgressReportStore();
const {
  filters: {
    value: { attendees },
  },
  attendeeName,
} = storeToRefs(progressReportStore);

const includeCaseloadManagement = ref(false);

const summary = ref('');

onMounted(() => init());

onUnmounted(() => progressReportStore.$reset());

$routing.routeChangeWatcher(() => {
  if (isProgressReport.value || isUserProgressReport.value) {
    progressReportStore.queryParams = $routing.route.query;
    defineFilters();
    doProgressReport();
  }
});

watch(
  () => [
    reportStore.filters.clinicians.selected,
    reportStore.filters.dates,
    reportStore.filters.organizations.selected,
  ],
  () => progressReportStore.getAttendees(),
);

// Disable the ability to download if no summary has been entered or
// a download is currently in progress.
const isDownloadDisabled = computed<boolean>(() => summary.value === '' || progressReportStore.progress.downloading);

const hasAttendeeSelected = computed<boolean>(() => !!attendees.selected || !!+studentId.value);

// TODO: If this report is necessary in additional areas of the application then
// this section could use some changes in order for adjustments.
const isProgressReport = computed<boolean>(() => $routing.route.name === 'reports.progress');
const isUserProgressReport = computed<boolean>(() => $routing.route.name === 'user.progress');

const progressReportData = computed<ProgressReportInterface[]>(() => progressReportStore.progress.data);

const reportAttendeeName = computed(() =>
  isUserProgressReport.value ? profileStore.person?.display_name : attendeeName.value,
);

const reportDates = computed(
  () =>
    `${useDateTime().formatDateShortMonth(reportStore.filters.dates[0])} - ${useDateTime().formatDateShortMonth(
      reportStore.filters.dates[1],
    )}`,
);

const init = async () => {
  // The reports section of the progress report requires the following
  // before it can go about doing anything.
  if (isProgressReport.value) {
    if (can([PERMISSIONS.REPORTS_FILTER_SERVICE_PROVIDERS])) await progressReportStore.getAttendees();
    await defineFilters();
    await doProgressReport();
  }

  // The user section of the progress report only requires date query
  // params to be loaded initially.
  if (isUserProgressReport.value) {
    reportStore.defineDefaultDates();
    doProgressReport();
  }
};

const doProgressReport = async () => {
  const params = $routing.route.query;
  const hasDateParams = params.start_at && params.end_at;
  const hasRequiredParams = hasDateParams && hasAttendeeSelected.value;

  // Make sure that all required query params exist before firing the request.
  if (hasRequiredParams) {
    // Only force add the attendee param for the user profile route.
    if (isUserProgressReport.value) params.attendee = studentId.value;
    await progressReportStore.getProgressReport($routing.route.query);
  }
};

const defineFilters = async () => {
  const query = $routing.route.query;
  attendees.selected = parseInt(query.attendee) || 0;
  includeCaseloadManagement.value = !!+query.cm;

  // Add back the query params for the report once it regains focus again.
  if (progressReportStore.queryParams) {
    $routing.addQueryParams(progressReportStore.queryParams);
  } else {
    emit(EMIT.QUERY_PARAMS);
  }
};

const defineLocation = (location) => {
  return location
    ? [location.address, location.city?.name, location.state?.code, location.zipcode]
        .filter((item) => !!item)
        .join(', ')
    : 'N/A';
};

const defineOrganizations = (organizations) => {
  return organizations?.length ? organizations.map((item) => item.name).join(', ') : 'N/A';
};

const defineAge = (birthday) => (birthday?.length ? useDateTime().getAge(birthday) : 'N/A');

const defineBirthDate = (birthday) => (birthday?.length ? useDateTime().formatToMMDDYYYY(birthday) : 'N/A');

const defineClinicians = (clinicians) => {
  return clinicians?.length ? clinicians.map((item) => item.full_name).join(', ') : 'N/A';
};

const definePhone = (location) => (location?.phone?.length ? location.phone : 'N/A');

const defineMeasurementPercentage = (measurement) => `${measurement ? Math.round(measurement) : 0}%`;

const onAttendeeChange = (event: DropdownChangeEvent) => {
  summary.value = '';

  if (event.value) {
    $routing.addQueryParam('attendee', event.value);
  } else {
    $routing.removeQueryParam('attendee');
  }
};

const onDownloadReport = async () => {
  const data = progressReportData.value;
  data.age = useDateTime().getAge(data.birthday);

  const payload = {
    summary: summary.value,
    data: progressReportData.value,
    start_at: useDateTime().formatDateForApi(reportStore.filters.dates[0]),
    end_at: useDateTime().formatDateForApi(reportStore.filters.dates[1]),
  };

  const response = await progressReportStore.downloadProgressReport(payload);
  reportHtml.value = response;
  showIframe.value = true;

  nextTick(() => {
    const printFrame = document.getElementById('progress-report-frame');
    if (printFrame) {
      const frameWindow = printFrame.contentWindow;
      if (frameWindow) {
        frameWindow.onafterprint = () => {
          showIframe.value = false;
        };
        setTimeout(() => {
          frameWindow.print();
        }, 500);
      }
    }
  });
};

const onIncludeCaseloadManagement = () => $routing.addQueryParam('cm', includeCaseloadManagement.value ? '1' : '0');

return (_ctx: any,_cache: any) => {
  const _component_Dropdown = _resolveComponent("Dropdown")!
  const _component_AppDateRangePicker = _resolveComponent("AppDateRangePicker")!
  const _component_InputSwitch = _resolveComponent("InputSwitch")!
  const _component_AppButton = _resolveComponent("AppButton")!
  const _component_InputText = _resolveComponent("InputText")!
  const _component_Column = _resolveComponent("Column")!
  const _component_DataTable = _resolveComponent("DataTable")!
  const _component_Card = _resolveComponent("Card")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    (showIframe.value)
      ? (_openBlock(), _createElementBlock("iframe", {
          key: 0,
          id: "progress-report-frame",
          srcdoc: reportHtml.value,
          class: "print-iframe"
        }, null, 8, _hoisted_2))
      : _createCommentVNode("", true),
    _createVNode(_component_Card, null, {
      content: _withCtx(() => [
        _createElementVNode("div", _hoisted_3, [
          _createElementVNode("div", _hoisted_4, [
            (!_unref(studentId) && _unref(can)([_unref(PERMISSIONS).REPORTS_FILTER_SERVICE_PROVIDERS]))
              ? (_openBlock(), _createBlock(_component_Dropdown, {
                  key: 0,
                  id: "reports_progress_attendee",
                  modelValue: _unref(attendees).selected,
                  "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((_unref(attendees).selected) = $event)),
                  options: _unref(attendees).options,
                  loading: _unref(attendees).loading,
                  filter: true,
                  "reset-filter-on-hide": true,
                  class: "w-full",
                  "option-label": "name",
                  "option-value": "value",
                  placeholder: "Attendee",
                  onChange: onAttendeeChange
                }, null, 8, ["modelValue", "options", "loading"]))
              : (_openBlock(), _createBlock(_component_AppDateRangePicker, {
                  key: 1,
                  modelValue: _unref(reportStore).filters.dates,
                  "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event: any) => ((_unref(reportStore).filters.dates) = $event)),
                  value: _unref(reportStore).filters.dates,
                  onChange: _unref(reportStore).onDateRangeChange
                }, null, 8, ["modelValue", "value", "onChange"]))
          ]),
          _createElementVNode("div", _hoisted_5, [
            _createElementVNode("div", _hoisted_6, [
              _createVNode(_component_InputSwitch, {
                modelValue: includeCaseloadManagement.value,
                "onUpdate:modelValue": _cache[2] || (_cache[2] = ($event: any) => ((includeCaseloadManagement).value = $event)),
                onInput: onIncludeCaseloadManagement
              }, null, 8, ["modelValue"])
            ]),
            _cache[5] || (_cache[5] = _createElementVNode("div", {
              class: "pt-2 text-gray-600",
              style: {"float":"left"}
            }, [
              _createElementVNode("label", null, "Include Caseload Management")
            ], -1))
          ]),
          _createElementVNode("div", _hoisted_7, [
            _createVNode(_component_AppButton, {
              type: "secondary",
              text: "Download",
              "icon-left": "system_update_alt",
              disabled: isDownloadDisabled.value,
              onClick: onDownloadReport
            }, null, 8, ["disabled"])
          ])
        ]),
        (!hasAttendeeSelected.value)
          ? (_openBlock(), _createElementBlock("div", _hoisted_8, [...(_cache[6] || (_cache[6] = [
              _createElementVNode("div", { class: "flex-auto flex align-items-center justify-content-center surface-100 border-round" }, [
                _createElementVNode("span", { class: "text-800 text-xs" }, "Select an Attendee to see Progress Report")
              ], -1)
            ]))]))
          : (_openBlock(), _createElementBlock(_Fragment, { key: 1 }, [
              _createVNode(ReportSubjectTitle, {
                title: "Progress",
                name: reportAttendeeName.value,
                dates: _unref(reportStore).filters.dates
              }, null, 8, ["name", "dates"]),
              _createElementVNode("div", _hoisted_9, [
                _createElementVNode("div", _hoisted_10, [
                  _createElementVNode("div", _hoisted_11, [
                    _cache[7] || (_cache[7] = _createElementVNode("label", {
                      for: "username",
                      class: "required"
                    }, "Summary", -1)),
                    _createVNode(_component_InputText, {
                      id: "summary",
                      modelValue: summary.value,
                      "onUpdate:modelValue": _cache[3] || (_cache[3] = ($event: any) => ((summary).value = $event)),
                      type: "text",
                      class: "w-full",
                      placeholder: "Enter progress report summary here"
                    }, null, 8, ["modelValue"])
                  ])
                ])
              ]),
              _createElementVNode("div", _hoisted_12, [
                _createElementVNode("div", _hoisted_13, [
                  _createElementVNode("div", _hoisted_14, [
                    _cache[9] || (_cache[9] = _createElementVNode("div", { class: "col text-left" }, [
                      _createElementVNode("img", {
                        alt: "eLuma logo",
                        height: "36",
                        src: _imports_0
                      }),
                      _createElementVNode("img", {
                        class: "mb-2 ml-2",
                        alt: "eLuma text",
                        height: "17",
                        src: _imports_1
                      })
                    ], -1)),
                    _createElementVNode("div", _hoisted_15, [
                      _cache[8] || (_cache[8] = _createElementVNode("p", { class: "text-xl font-semibold text-600" }, "Progress Report", -1)),
                      _createElementVNode("p", {
                        textContent: _toDisplayString(reportDates.value)
                      }, null, 8, _hoisted_16)
                    ])
                  ]),
                  _createElementVNode("div", _hoisted_17, [
                    _createElementVNode("div", _hoisted_18, [
                      _cache[18] || (_cache[18] = _createElementVNode("h2", { class: "pt-2 pb-2 text-600" }, "Student", -1)),
                      _createElementVNode("div", _hoisted_19, [
                        _createElementVNode("div", _hoisted_20, [
                          _createElementVNode("div", _hoisted_21, [
                            _cache[10] || (_cache[10] = _createElementVNode("div", { class: "col text-right text-600" }, "SSID", -1)),
                            _createElementVNode("div", _hoisted_22, _toDisplayString(progressReportData.value.external_association
                              ? progressReportData.value.external_association.external_id
                              : 'N/A'), 1)
                          ]),
                          _createElementVNode("div", _hoisted_23, [
                            _cache[11] || (_cache[11] = _createElementVNode("div", { class: "col text-right text-600" }, "Name", -1)),
                            _createElementVNode("div", _hoisted_24, [
                              _createElementVNode("span", {
                                textContent: _toDisplayString(progressReportData.value.full_name)
                              }, null, 8, _hoisted_25)
                            ])
                          ]),
                          _createElementVNode("div", _hoisted_26, [
                            _cache[12] || (_cache[12] = _createElementVNode("div", { class: "col text-right text-600" }, "Address", -1)),
                            _createElementVNode("div", _hoisted_27, [
                              _createElementVNode("span", {
                                textContent: _toDisplayString(defineLocation(progressReportData.value.location))
                              }, null, 8, _hoisted_28)
                            ])
                          ]),
                          _createElementVNode("div", _hoisted_29, [
                            _cache[13] || (_cache[13] = _createElementVNode("div", { class: "col text-right text-600" }, "Phone", -1)),
                            _createElementVNode("div", _hoisted_30, [
                              _createElementVNode("span", {
                                textContent: _toDisplayString(definePhone(progressReportData.value.location))
                              }, null, 8, _hoisted_31)
                            ])
                          ]),
                          _createElementVNode("div", _hoisted_32, [
                            _cache[14] || (_cache[14] = _createElementVNode("div", { class: "col text-right text-600" }, "Date of Birth", -1)),
                            _createElementVNode("div", _hoisted_33, [
                              _createElementVNode("span", {
                                textContent: _toDisplayString(defineBirthDate(progressReportData.value.birthday))
                              }, null, 8, _hoisted_34)
                            ])
                          ]),
                          _createElementVNode("div", _hoisted_35, [
                            _cache[15] || (_cache[15] = _createElementVNode("div", { class: "col text-right text-600" }, "Age", -1)),
                            _createElementVNode("div", _hoisted_36, [
                              _createElementVNode("span", {
                                textContent: _toDisplayString(defineAge(progressReportData.value.birthday))
                              }, null, 8, _hoisted_37)
                            ])
                          ])
                        ]),
                        _createElementVNode("div", _hoisted_38, [
                          _createElementVNode("div", _hoisted_39, [
                            _cache[16] || (_cache[16] = _createElementVNode("div", { class: "col text-right text-600" }, "Customer", -1)),
                            _createElementVNode("div", _hoisted_40, [
                              _createElementVNode("span", {
                                textContent: _toDisplayString(defineOrganizations(progressReportData.value.organizations))
                              }, null, 8, _hoisted_41)
                            ])
                          ]),
                          _createElementVNode("div", _hoisted_42, [
                            _cache[17] || (_cache[17] = _createElementVNode("div", { class: "col text-right text-600" }, "Service Providers", -1)),
                            _createElementVNode("div", _hoisted_43, [
                              _createElementVNode("span", {
                                textContent: _toDisplayString(defineClinicians(progressReportData.value.clinicians))
                              }, null, 8, _hoisted_44)
                            ])
                          ])
                        ])
                      ])
                    ])
                  ]),
                  _createElementVNode("div", _hoisted_45, [
                    _createElementVNode("div", _hoisted_46, [
                      _cache[22] || (_cache[22] = _createElementVNode("h2", { class: "pt-2 pb-2 text-600" }, "Services", -1)),
                      _createElementVNode("div", _hoisted_47, [
                        _createElementVNode("div", _hoisted_48, [
                          _createVNode(_component_DataTable, {
                            expandedRows: expandedRows.value,
                            "onUpdate:expandedRows": _cache[4] || (_cache[4] = ($event: any) => ((expandedRows).value = $event)),
                            value: progressReportData.value.treatment_services,
                            "responsive-layout": "scroll"
                          }, {
                            empty: _withCtx(() => [...(_cache[19] || (_cache[19] = [
                              _createTextVNode("No services found", -1)
                            ]))]),
                            expansion: _withCtx((slotProps) => [
                              _createElementVNode("div", _hoisted_54, [
                                _cache[21] || (_cache[21] = _createElementVNode("h2", { class: "pb-2 text-600" }, "Goals", -1)),
                                _createElementVNode("div", _hoisted_55, [
                                  _createElementVNode("div", _hoisted_56, [
                                    _createVNode(_component_DataTable, {
                                      value: slotProps.data.goals,
                                      "responsive-layout": "scroll"
                                    }, {
                                      empty: _withCtx(() => [...(_cache[20] || (_cache[20] = [
                                        _createTextVNode("No goals found", -1)
                                      ]))]),
                                      default: _withCtx(() => [
                                        _createVNode(_component_Column, {
                                          field: "treatment_goal_type.title",
                                          header: "Type"
                                        }),
                                        _createVNode(_component_Column, {
                                          field: "description",
                                          header: "Description"
                                        }),
                                        _createVNode(_component_Column, {
                                          field: "measurements_avg_percentage",
                                          header: "Percentage"
                                        }, {
                                          body: _withCtx(({ data }) => [
                                            _createElementVNode("span", {
                                              class: "ml-4",
                                              textContent: _toDisplayString(defineMeasurementPercentage(data.measurements_avg_percentage))
                                            }, null, 8, _hoisted_57)
                                          ]),
                                          _: 1
                                        }),
                                        _createVNode(_component_Column, {
                                          field: "data",
                                          header: "Quantity"
                                        }, {
                                          body: _withCtx(({ data }) => [
                                            _createVNode(ProgressReportQuantity, {
                                              "goal-id": data.id
                                            }, null, 8, ["goal-id"])
                                          ]),
                                          _: 1
                                        }),
                                        _createVNode(_component_Column, {
                                          field: "data",
                                          header: "Intensity"
                                        }, {
                                          body: _withCtx(({ data }) => [
                                            _createVNode(ProgressReportIntensity, {
                                              "goal-id": data.id
                                            }, null, 8, ["goal-id"])
                                          ]),
                                          _: 1
                                        }),
                                        _createVNode(_component_Column, {
                                          field: "data",
                                          header: "Intensity Type"
                                        }, {
                                          body: _withCtx(({ data }) => [
                                            _createVNode(ProgressReportIntensityType, {
                                              "goal-id": data.id
                                            }, null, 8, ["goal-id"])
                                          ]),
                                          _: 1
                                        })
                                      ]),
                                      _: 1
                                    }, 8, ["value"])
                                  ])
                                ])
                              ])
                            ]),
                            default: _withCtx(() => [
                              _createVNode(_component_Column, {
                                field: "",
                                expander: true,
                                "header-class": "no-center",
                                "header-style": "width: 20px"
                              }),
                              _createVNode(_component_Column, {
                                field: "code",
                                header: "Service"
                              }, {
                                body: _withCtx(({ data }) => [
                                  _createElementVNode("p", {
                                    class: "text-base font-semibold",
                                    textContent: _toDisplayString(data.service.name)
                                  }, null, 8, _hoisted_49),
                                  _createElementVNode("p", {
                                    textContent: _toDisplayString(data.discipline.name)
                                  }, null, 8, _hoisted_50)
                                ]),
                                _: 1
                              }),
                              _createVNode(_component_Column, {
                                field: "duration",
                                header: "Duration"
                              }, {
                                body: _withCtx(({ data }) => [
                                  _createElementVNode("span", {
                                    class: "ml-4",
                                    textContent: _toDisplayString(data.duration)
                                  }, null, 8, _hoisted_51)
                                ]),
                                _: 1
                              }),
                              _createVNode(_component_Column, {
                                field: "start_at",
                                header: "Start Date"
                              }, {
                                body: _withCtx(({ data }) => [
                                  _createElementVNode("span", {
                                    textContent: _toDisplayString(_unref(useDateTime)().formatIntlDate(data.start_at))
                                  }, null, 8, _hoisted_52)
                                ]),
                                _: 1
                              }),
                              _createVNode(_component_Column, {
                                field: "end_at",
                                header: "End Date"
                              }, {
                                body: _withCtx(({ data }) => [
                                  _createElementVNode("span", {
                                    textContent: _toDisplayString(_unref(useDateTime)().formatIntlDate(data.end_at))
                                  }, null, 8, _hoisted_53)
                                ]),
                                _: 1
                              })
                            ]),
                            _: 1
                          }, 8, ["expandedRows", "value"])
                        ])
                      ])
                    ])
                  ]),
                  _createElementVNode("div", _hoisted_58, [
                    _createElementVNode("div", _hoisted_59, [
                      _cache[24] || (_cache[24] = _createElementVNode("h2", { class: "pt-2 pb-2 text-600" }, "Events", -1)),
                      _createElementVNode("div", _hoisted_60, [
                        _createElementVNode("div", _hoisted_61, [
                          _createVNode(_component_DataTable, {
                            value: progressReportData.value.events,
                            "responsive-layout": "scroll"
                          }, {
                            empty: _withCtx(() => [...(_cache[23] || (_cache[23] = [
                              _createTextVNode("No events found", -1)
                            ]))]),
                            default: _withCtx(() => [
                              _createVNode(_component_Column, {
                                field: "start_at",
                                header: "Date"
                              }, {
                                body: _withCtx(({ data }) => [
                                  _createElementVNode("span", {
                                    textContent: _toDisplayString(data.date)
                                  }, null, 8, _hoisted_62)
                                ]),
                                _: 1
                              }),
                              _createVNode(_component_Column, {
                                field: "start_at",
                                header: "Time"
                              }, {
                                body: _withCtx(({ data }) => [
                                  _createElementVNode("span", {
                                    textContent: _toDisplayString(data.time)
                                  }, null, 8, _hoisted_63)
                                ]),
                                _: 1
                              }),
                              _createVNode(_component_Column, {
                                field: "event_type",
                                header: "Event Type"
                              }),
                              _createVNode(_component_Column, {
                                field: "service_provider",
                                header: "Service Provider"
                              }),
                              _createVNode(_component_Column, {
                                field: "results",
                                header: "Attn Type"
                              }, {
                                body: _withCtx(({ data }) => [
                                  _createElementVNode("span", {
                                    textContent: _toDisplayString(data.therapy_result_type)
                                  }, null, 8, _hoisted_64)
                                ]),
                                _: 1
                              }),
                              _createVNode(_component_Column, {
                                field: "results",
                                header: "Duration"
                              }, {
                                body: _withCtx(({ data }) => [
                                  _createElementVNode("span", {
                                    class: "ml-4",
                                    textContent: _toDisplayString(data.duration)
                                  }, null, 8, _hoisted_65)
                                ]),
                                _: 1
                              }),
                              _createVNode(_component_Column, {
                                field: "results",
                                header: "Notes"
                              }, {
                                body: _withCtx(({ data }) => [
                                  _createElementVNode("span", {
                                    textContent: _toDisplayString(data.notes)
                                  }, null, 8, _hoisted_66)
                                ]),
                                _: 1
                              })
                            ]),
                            _: 1
                          }, 8, ["value"])
                        ])
                      ])
                    ])
                  ])
                ])
              ])
            ], 64))
      ]),
      _: 1
    })
  ]))
}
}

})